import { observer } from "mobx-react";
import React from "react";
import { useIntl } from "react-intl";
import { default as styled, createGlobalStyle } from "styled-components";
import { VBox } from "@web/elements";
import { Logo } from "@web/elements/Logo";
import { vars } from "@web/styles";
import { commonTexts } from "@web/translations";

export const AuthenticationErrorPage = observer(() => {
  const intl = useIntl();

  return (
    <>
      <NoBodyMarginStyle />
      <PageWrapper>
        <ContentContainer>
          <StyledLogo />
          <ErrorTitle>
            {intl.formatMessage(commonTexts.clientSecretErrorTitle)}
          </ErrorTitle>
          <InstructionText>
            {intl.formatMessage(commonTexts.clientSecretErrorInstruction)}
          </InstructionText>
        </ContentContainer>
      </PageWrapper>
    </>
  );
});

const NoBodyMarginStyle = createGlobalStyle`
  body {
    margin: 0;
  }
`;

const PageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-color: #f0f1fe;
  overflow: hidden;
`;

const ContentContainer = styled(VBox)`
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 600px;
  padding: 1.5rem;
  gap: 2rem;
`;

const StyledLogo = styled(Logo)`
  width: 120px;
  height: 120px;
  color: ${vars.primary};
`;

const ErrorTitle = styled.h1`
  font-size: 26px;
  font-weight: 500;
  line-height: 1.4;
  color: ${vars.bodyFg};
  margin: 0;
  max-width: 600px;
`;

const InstructionText = styled.p`
  font-size: 20px;
  font-weight: 400;
  line-height: 1.5;
  color: ${vars.dark55};
  margin: 0;
  max-width: 600px;
`;
